import React from 'react';
import { DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { EditHealthDialog, EditStatusDialog } from './shared/CoinDialogs';
import { GGDialog, GGDialogTitle } from './shared/StyledDialogs';
import MonsterInfoModal from './shared/MonsterInfoModal';
import { getMonsterRawByIndex } from '../services/monsterService';
import { useGame } from '../context/GameContext';

const CoinContextOverlay = () => {
  const {
    selectedCoinId,
    selectedCoin: coin,
    showHealthDialog,
    showStatusDialog,
    showStatBlockDialog,
    showDeleteConfirm,
    showRemoveConfirm,
    setShowHealthDialog,
    setShowStatusDialog,
    setShowStatBlockDialog,
    setShowDeleteConfirm,
    setShowRemoveConfirm,
    onEditCoinHealth,
    onEditCoinStatus,
    onOverlayConfirmDelete,
    onOverlayConfirmRemove,
  } = useGame();

  if (!selectedCoinId || !coin) return null;

  return (
    <>
      <EditHealthDialog
        open={showHealthDialog}
        onClose={() => setShowHealthDialog(false)}
        coin={coin}
        onSave={(health) => {
          onEditCoinHealth(coin.id, health);
          setShowHealthDialog(false);
        }}
      />

      <EditStatusDialog
        open={showStatusDialog}
        onClose={() => setShowStatusDialog(false)}
        coin={coin}
        onSave={(statuses) => {
          onEditCoinStatus(coin.id, statuses);
          setShowStatusDialog(false);
        }}
      />

      {coin.isEnemy && coin.monsterData && (
        <MonsterInfoModal
          open={showStatBlockDialog}
          onClose={() => setShowStatBlockDialog(false)}
          rawMonster={
            coin.monsterData.index
              ? getMonsterRawByIndex(coin.monsterData.index)
              : null
          }
          coin={coin}
        />
      )}

      <GGDialog open={showDeleteConfirm} onClose={() => setShowDeleteConfirm(false)} maxWidth="xs" fullWidth>
        <GGDialogTitle>Delete Token</GGDialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Typography sx={{ fontFamily: 'MedievalSharp' }}>
            Are you sure you want to delete {coin.name || 'this token'}?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={() => setShowDeleteConfirm(false)}
            variant="contained"
            sx={{ fontFamily: 'MedievalSharp' }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              onOverlayConfirmDelete();
              setShowDeleteConfirm(false);
            }}
            color="error"
            sx={{ fontFamily: 'MedievalSharp' }}
          >
            Yes
          </Button>
        </DialogActions>
      </GGDialog>

      <GGDialog open={showRemoveConfirm} onClose={() => setShowRemoveConfirm(false)} maxWidth="xs" fullWidth>
        <GGDialogTitle>Remove from Grid</GGDialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Typography sx={{ fontFamily: 'MedievalSharp' }}>
            Remove {coin.name || 'this token'} from the grid? It will remain in the Initiative panel.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={() => setShowRemoveConfirm(false)}
            variant="contained"
            sx={{ fontFamily: 'MedievalSharp' }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              onOverlayConfirmRemove();
              setShowRemoveConfirm(false);
            }}
            color="warning"
            sx={{ fontFamily: 'MedievalSharp' }}
          >
            Yes
          </Button>
        </DialogActions>
      </GGDialog>
    </>
  );
};

export default CoinContextOverlay;
